<template>
  <div>
    <div class="content ">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">
            删除
          </el-button>
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div style="margin-bottom: 10px">
        <el-tabs v-if="type == 5 || type == 1" v-model="query.sourceType" @tab-click="tabClick" stretch style="width: 30%;">
          <el-tab-pane v-for="item in systemType" :key="item.id" :name="item.id">
            <template slot="label">
              <!--  -->
              <el-badge class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-table v-loading="loading" border ref="multipleTable" :data="tableData" :max-height="tableHeight" row-key="id"
        :tree-props="{ children: 'children' }" style="width: 100%;margin-top:10px"
        @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="180">
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.remark??'-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="parentName" label="父模块"></el-table-column>
        <el-table-column prop="code" label="编码"></el-table-column>
        <el-table-column prop="sort" label="排序" width="55"></el-table-column> -->
        <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="stateName" label="是否展示" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="operation" label="操作" width="180px">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
              @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue"
              v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title  + (isDrug?this.route.menuName:'模块')" :visible.sync="open" :center="true" width="1100px" :before-close="cancel"
        :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上级分类" prop="parentId">
                <SelectTree :disabled="!editMode" @handleCheckChange="handleCheckChange" :defaultProps="defaultProps"
                  :data="treeList" :defaultValue="form.parentName" style="width:100%"></SelectTree>
                <!-- <el-select v-model="form.parentId" placeholder="请选择父模块" filterable :filter-method="getParentId" style="width: 100%;" @change="parentModeuleChange">
                  <el-option v-for="item in parentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-if="type == 5 || type == 1">
              <el-form-item :label="this.route.menuName + '类型'" prop="sourceTypes">
                <el-select :disabled="!editMode" v-model="form.sourceTypeName" multiple placeholder="请选择模块"
                  @change="systemTypeChange" style="width: 100%;">
                  <el-option v-for="item in systemType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确
            定</my-button>
        </div>
      </el-dialog>
    </div>
    <!-- <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import {
  SaveSecondaryDictionary,
  RemoveSecondaryDictionarys,
  SecondaryDictionaryTree,
  ExportBillRegister,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectTree from '@/components/select-tree'
import SelectFilter from "@/components/table-select-filter";

export default {
  components: {
    // IconSelect
    SelectTree,
    SelectFilter
  },
  mixins: [GetDataMixin],
  data() {
    return {
      exportAction: ExportBillRegister,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: 0,
        sourceType: '1',
      },
      // 遮罩层
      loading: true,
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      rules: {
        name: [{ required: true, message: "请选择名称", trigger: "blur" }],
        sourceType: [{ required: true, message: "请选择模块", trigger: "blur" }],
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treeList: [],
      filterOptions: [
        {
          name: "名称",
          type: "input",
          code: "name",
        },
      ],
      systemType: [
        {
          id: '1',
          name: "耗材",
        },
        {
          id: '2',
          name: "药品",
        },
      ],
    };
  },
  props: {
    type: {
      type: Number,
      default() {
        return 0
      }
    },
    isDrug:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    apps() {
      return this.$store.state.user.apps;
    },
  },
  methods: {
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
      this.loading = true;
      if (this.type == 17) {
        this.query.sourceType = 2
      }
      SecondaryDictionaryTree(this.query).then((res) => {
        this.tableData = res.returnData;
        // this.total = res.returnData.totalCount;
        this.loading = false;
      });
    },
    // 新建
    handleAdd() {
      this.open = true;
      this.resetForm();
      this.getTreeList('')
      this.editMode = true;
      this.title = "新建";
    },
    handleInfo(row) {
      this.resetForm();
      row.sourceTypeName = row.sourceTypes.split(';').map(item => Number(item))
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate(row) {
      this.resetForm();
      row.sourceTypeName = row.sourceTypes.split(';').map(item => Number(item))
      this.form = JSON.parse(JSON.stringify(row));
      // if (this.form.parentId == 0) {
      //   this.form.parentId = null;
      // }
      this.title = "编辑";
      this.open = true;
      this.getTreeList('')
      this.editMode = true;
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.type == 17) {
          this.form.sourceTypes = 2
        }
        SaveSecondaryDictionary(this.form).then((res) => {
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData();
        }).finally(() => {
          this.$store.dispatch('SetLoading', false)
        });;
      });
    },
    resetForm() {
      this.form = {
        name: "",
        type: this.type,
        orgCode: sessionStorage.getItem('orgId')
      };
    },
    systemTypeChange(val) {
      this.form.sourceTypes = val.join(';')
    },
    // 取消编辑部门
    cancel() {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    tabClick() {
      this.getData();
      this.getParentId();
    },
    // 删除部门
    handleDelete(row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveSecondaryDictionarys({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        appId: "1",
        type: this.type,
        sourceType: 1,
        orgCode: sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    handleCheckChange(node) {
      if (node) {
        this.form.parentId = node.id;
        this.form.parentName = node.name;
      }
      else {
        this.form.parentId = '';
        this.form.parentName = '';
      }
    },
    getTreeList() {
      let query = { type: this.type }
      SecondaryDictionaryTree(query).then((response) => {
        this.treeList = response.returnData
      });
    },
    filterChange(query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
  },
  mounted() {
    this.query.type = this.type
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
